import React from 'react';
import { List, ListItem } from '@powerednow/components/List/List';
import { ListItemButton } from '@mui/material';
import { ComplexModelEntity } from '@powerednow/models/modelLookup';
import { styled } from '@mui/material/styles';
import { useWorkflow } from './hooks';

const WorkflowListRoot = styled(List, {
    name: 'WorkflowList',
    slot: 'root',
})(() => ({
    width: '300px',
}));

export default function WorkflowList({ onItemSelected }: {
    onItemSelected?: (workflow: ComplexModelEntity<'Workflow'>) => void
}) {
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const workflows = useWorkflow() || [];

    const handleListItemClick = (
        event: React.MouseEvent,
        index: number,
    ) => {
        if (onItemSelected) {
            onItemSelected(workflows[index]);
        }
        setSelectedIndex(index);
    };

    return (
        <WorkflowListRoot disablePadding subheader={null}>
            {workflows.map((workflow, index) => (
                <ListItem
                    key={workflow.id}
                >
                    <ListItemButton
                        selected={selectedIndex === index}
                        onClick={event => handleListItemClick(event, index)}
                    >
                        <span>
                            <b>{workflow.title}</b>
                            &nbsp;-&nbsp;
                            {workflow.description}
                        </span>
                    </ListItemButton>
                </ListItem>
            ))}
        </WorkflowListRoot>
    );
}
